var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publishings"},[(!_vm.isInApp)?_c('hero'):_vm._e(),_c('trending-publishings',{attrs:{"publishings":_vm.publishings,"loading":_vm.loading,"bookMarks":_vm.bookMarks,"follwedBloggers":_vm.follwedBloggers},on:{"bookMarkBlog":_vm.handleToggleShelfPublishing}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }